module.exports = __webpack_public_path__ + "img/mouse.d167a15c.svg";